module.exports = __webpack_public_path__ + "media/images/icon/move-49a618479ff03aa709c6a9ff274e898e.svg";